module.exports = __webpack_public_path__ + "images/emails/page-b-blue-6b25c1e3.gif";